import React, { Component } from 'react'
import { getUser } from '../../actions/session'
import Axios from 'axios'
import { Notifications } from '../common/notification';
import { CARRIER_UPDATE } from '../../config/rest_endpoints';
import Switch from "react-switch";


class CarrierEdit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            U_carrierId: '',
            U_session: '',
            U_cps: '',
            U_prefix: '',
            U_status: '',
            msg: '',
            prefix: '',
            holdTime:'',
            name:'',
            switched: true,
            isLoad: false
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
    }

    componentWillReceiveProps(newProps) {
        const {previousData} = newProps
        this.setState({
            U_session: previousData.sessions === undefined ? "" : previousData.sessions,
            U_cps:previousData['cps'] === undefined ? "" : previousData['cps'] ,
            prefix: previousData.prefix === undefined ? "" : previousData.prefix,
            switched:previousData.status ,
            holdTime:previousData.holdTime  === undefined ? "" : previousData.holdTime  ,
            name:previousData.name
            // U_carrierId:newProps.previousData.carrierID,
            // U_prefix:newProps.previousData.prefix,
            // U_status:newProps.previousData.status
        })
    }

    toggleSwitch() {
        this.setState({ switched: !this.state.switched })
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit() {
        const { previousData } = this.props
        const { U_cps, U_session, carrierId, switched, prefix, holdTime, name } = this.state
        var id = previousData.id
        var spID = '5e53b3847d43000085004d04'
        console.log('name :>> ', name);
        var payload = {
            "name":name,
            "carrierID": parseInt(previousData.carrierID),
            "sessions": parseInt(U_session),
            "cps": parseInt(U_cps),
            "holdTime": parseInt(holdTime) ,
            "prefix": prefix === '' ? null : prefix,
            "status": switched
        }
        this.setState({ isLoad: true })
        var headers = { 'Authorization': "Bearer " + this.state.User.token }
        Axios.put(`${CARRIER_UPDATE}/${id}/update`, payload, { headers }).then(res => {
            if (res) {
                this.props.close()
                this.props.carrierListing()
                this.setState({ isLoad: false })
                Notifications.notify("Carriers updated successfully", "Created", "success")
            }
            else {
                Notifications.notify("failed carrier update", "Failed", "error")
            }
        }).catch(err => {
            var msessage = err.response.data.message
            console.log(`msessage`, msessage)
            this.setState({ isLoad: false })
            Notifications.notify(msessage, "Failed", "error")
            this.props.close()
        })
    }

    render() {
        const { U_cps, U_session, prefix, holdTime,name } = this.state

        const labelStyle = {
            fontWeight: '500',
            fontSize: '13px',
            color: '#475569',
            marginBottom: '6px'
        };

        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Name</label>
                            <input type="text" className="form-control" name="name" value={name} onChange={this.handleChange} placeholder="Enter name" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Session</label>
                            <input type="number" className="form-control" name="U_session" value={U_session} onChange={this.handleChange} placeholder="Enter concurrent calls" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>CPS</label>
                            <input type="number" className="form-control" name="U_cps" value={U_cps} onChange={this.handleChange} placeholder="Enter CPS" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Prefix</label>
                            <input type="text" className="form-control" name="prefix" value={prefix} onChange={this.handleChange} placeholder="e.g. 3353#" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Hold Time</label>
                            <input type="text" className="form-control" name="holdTime" value={holdTime} onChange={this.handleChange} placeholder="Enter hold time" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group" style={{marginTop:'4px'}}>
                            <label style={labelStyle}>Carrier Status</label>
                            <div style={{marginTop:'4px'}}>
                                <Switch onChange={this.toggleSwitch} checked={this.state.switched} onColor="#10B981" offColor="#CBD5E1" height={22} width={44} handleDiameter={18} />
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{borderTop:'1px solid #E2E8F0',marginTop:'16px',paddingTop:'20px',display:'flex',justifyContent:'flex-end'}}>
                    <button
                        type="submit"
                        onClick={this.handleSubmit}
                        style={{
                            background: this.state.isLoad ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600',
                            cursor: this.state.isLoad ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: this.state.isLoad ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.3)',
                            transition: 'all 200ms ease'
                        }}
                    >
                        Update Carrier
                        <i className={this.state.isLoad ? "icon-spinner4 spinner" : "icon-pencil5"} style={{fontSize:'14px'}}></i>
                    </button>
                </div>
            </div>
        )
    }
}
export default CarrierEdit